import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
	theme: {
		themes: {
			light: {
				background: "#ECF5FD",
				primary: "#0093ee",
			},
			dark: {
				primary: "#0093ee",
			},
		},
	},
};

export default new Vuetify(opts);
